module.exports = __webpack_public_path__ + "img/img_phone_start_n.7090bf54.svg";